import * as yup from 'yup';
import UserPresenter from 'presenters/UserPresenter';

const validationFields = {
  email: yup
    .string()
    .email('validations.buyerProfile.email.invalid')
    .required('validations.buyerProfile.email.required')
    .max(50, 'validations.buyerProfile.email.maxLength'),
  firstName: yup.string().max(50, 'validations.buyerProfile.firstName.maxLength'),
  lastName: yup.string().max(50, 'validations.buyerProfile.lastName.maxLength'),
  phoneNumber: yup
    .string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      'validations.buyerProfile.phoneNumber.invalid',
    ),
};

export const getDefaultAttributes = user => {
  return {
    email: UserPresenter.email(user),
    firstName: UserPresenter.firstName(user) || '',
    lastName: UserPresenter.lastName(user) || '',
    phoneNumber: UserPresenter.phoneNumber(user) || '',
    keepUpdated: UserPresenter.keepUpdated(user),
  };
};

export default yup.object().shape({ ...validationFields });



// WEBPACK FOOTER //
// ./src/forms/buyerOptionalInfoForm.js